import { render } from "./LoadingTable.vue?vue&type=template&id=83aec4fc"
import script from "./LoadingTable.vue?vue&type=script&lang=js"
export * from "./LoadingTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__